/*
 * Store configuration in this file
 */

module.exports = {
	// Enable/Disable remote-redux-devtools
	ENABLE_REDUX_TOOLS: true,
	REDUX_TOOLS_HOST: '127.0.0.1',

	// Set the initial route stack on application load e.g [{name: 'Home'}] to automatically go to the home page
	INITIAL_ROUTE_STACK: undefined,

	// Set the test credentials for the application e.g. {username: 'test.user@email.com', password: 'Password1!'}
	TEST_CREDENTIALS: {username: '20011372-1', password: 'Password'},

	IDENTITYSERVER_ENDPOINT: 'https://identityserver-staging.mybudgetase.p.azurewebsites.net/',

	CLIENT_ID: 'ro.client',
	CLIENT_SECRET: 'PUT SECRET HERE',

	// MyBudget api endpoints
	MYBUDGETAPI_ENDPOINT: 'https://stagingmybudgetapi.azurewebsites.net/api/',
	WEBSOCKET_ENDPOINT: 'http://mbadevservices.cloudapp.net:8081',

	CLIENT_WEB: 'http://members.mbdinabox01.resources.mybudget.local',

	disabledFeatures: {}
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/mb-app-common/.env.js
// module id = 1659
// module chunks = 1